"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "new-appointment-container" };
const _hoisted_2 = { class: "appointment-head" };
const _hoisted_3 = { class: "home-title" };
const AppointmentItem_vue_1 = __importDefault(require("./AppointmentItem.vue"));
const bookedAppointmentsStore_1 = require("../../../stores/backend/bookedAppointments/bookedAppointmentsStore");
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const CompanyLocationStore_1 = require("../../../stores/backend/company/CompanyLocationStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Appointments',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const appointmentsStore = (0, bookedAppointmentsStore_1.useBookedAppointmentsStore)();
        const companyLocationStore = (0, CompanyLocationStore_1.useCompanyLocationStore)();
        (0, vue_3.watch)(() => [companyLocationStore.selectedLocation], async ([newSelectedLocation]) => {
            if (newSelectedLocation !== null) {
                await appointmentsStore.getAppointments(newSelectedLocation === null || newSelectedLocation === void 0 ? void 0 : newSelectedLocation.id);
                //első betöltésnél ha nincs benne adat akkor átirányítom a naptár nézetre
                if (!sessionStorage.getItem("redirectedToCalendar") &&
                    appointmentsStore.newAppointments.length === 0) {
                    sessionStorage.setItem("redirectedToCalendar", "true");
                    router.push({ name: "reservations_calendar_view" });
                }
            }
        }, { immediate: true } // Azonnali futtatás bekapcsolva
        );
        let setIntervalId = null;
        (0, vue_3.watch)(() => [companyLocationStore.selectedLocation], async ([newSelectedLocation]) => {
            if (newSelectedLocation !== null) {
                // Töröljük a korábbi setInterval-t, ha van
                if (setIntervalId) {
                    clearInterval(setIntervalId);
                }
                // Elindítjuk a setInterval-t
                setIntervalId = setInterval(() => {
                    appointmentsStore.getAppointments(newSelectedLocation === null || newSelectedLocation === void 0 ? void 0 : newSelectedLocation.id);
                }, 120000); // 120000 milliszekundum = 2 perc
            }
        }, { immediate: true } // Azonnali futtatás bekapcsolva
        );
        (0, vue_3.onUnmounted)(() => {
            // Töröljük a setInterval-t, ha a komponens lecsatolásra kerül
            if (setIntervalId) {
                clearInterval(setIntervalId);
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(_ctx.$trans("new_appointments", "New Reservations", "home")), 1)
                ]),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(appointmentsStore).newAppointments, (appointment) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AppointmentItem_vue_1.default, {
                        key: appointment.id,
                        email: appointment.email,
                        "arrived-date": new Date(appointment.created_at),
                        "service-bay": appointment.bayName,
                        "booked-date": new Date(appointment.booked_date),
                        "booked-time": new Date(appointment.booked_time),
                        "license-plate": appointment.plate_number,
                        "car-brand": appointment.car_make,
                        "car-model": appointment.car_model,
                        "data-app": appointment.booked_date + ' ' + appointment.booked_time,
                        onAccept: ($event) => ((0, vue_2.unref)(appointmentsStore).acceptAppointment(appointment.id)),
                        onDecline: ($event) => ((0, vue_2.unref)(appointmentsStore).declineAppointment(appointment.id))
                    }, null, 8, ["email", "arrived-date", "service-bay", "booked-date", "booked-time", "license-plate", "car-brand", "car-model", "data-app", "onAccept", "onDecline"]));
                }), 128))
            ]));
        };
    }
});
